module.exports = __WEBPACK_EXTERNAL_MODULE__65554__;